import React from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import NativeSelect from '@mui/material/NativeSelect'
import { ChronoSelectProps } from '@/layouts/core/types/core'

const ChronoSelect = (props: ChronoSelectProps) => {
  const { name, label, defaultValue, options, onUpdate } = props
  return (
    <FormControl 
      data-cy={props['data-cy']}
      fullWidth={props.fullWidth} 
      sx={props.sx}>
      
      <InputLabel variant="standard" htmlFor="uncontrolled-native">
        {label}
      </InputLabel>
      <NativeSelect
        defaultValue={defaultValue}
        onChange={(e) => {
          const value = e.target.selectedOptions[0]?.value
          // console.log(`Updating: ${value}`, {
          //   opts: e.target.selectedOptions
          // })
          onUpdate && onUpdate(value)
        }}
        inputProps={{
          name,
          id: 'uncontrolled-native',
        }}
      >
        {options.map(opt => (
          <option key={opt.name} value={opt.value}>{opt.name}</option>
        ))}

      </NativeSelect>
    </FormControl>
  )
}
export default ChronoSelect